import React from 'react'
import {connect} from 'react-redux'

import * as actions from '../actions'
import AuthForm from './AuthForm'
import PageWrapper from './PageWrapper'

const RequestReset = props => (
  <AuthForm
    title="Forgot password?"
    submitText="Send me password reset link"
    showEmail
    authError={props.status.msg}
    {...props}
  />
)

const RequestResetPage = PageWrapper(RequestReset)

const mapStateToProps = state => ({
  email: state.auth.email,
  status: state.auth.status.reset
})

const mapDispatchToProps = dispatch => ({
  onLoginClick: () => window.location = '/login',
  onEmailChange: email => dispatch(actions.setEmail(email)),
  onSubmit: () => dispatch(actions.requestPasswordReset())
})

const RequestResetWrapper = connect(mapStateToProps, mapDispatchToProps)(RequestResetPage)

export {RequestResetWrapper as default, RequestReset}


// WEBPACK FOOTER //
// ./assets/auth/components/RequestResetPage.js